import { nothing as s } from "lit";
import { classMap as h } from "lit/directives/class-map.js";
import { unsafeStatic as l, literal as n, html as i } from "lit/static-html.js";
import { getCustomElementSuffix as $ } from "../../api/custom-element-scope.js";
import { checkTextTruncate as r, checkWebkitTruncate as _ } from "../../utils/helpers.js";
const a = n`dss-icon-button${l($())}`, p = n`dss-button${l($())}`, t = n`dss-icon${l($())}`, u = n`dss-badge${l($())}`, d = n`dss-tooltip${l($())}`, b = (e) => i`
  <div
    class=${h({
  "dss-header-menu-patient": !0,
  "dss-header-menu-patient--jcef": e.jcef,
  [`dss-header-menu-patient--${e.variant}`]: !!e.variant
})}
  >
    <div class="dss-header-menu-patient-avatar">
      <slot name="avatar"></slot>
    </div>
    <div class="dss-header-menu-patient-details">
      <div class="dss-header-menu-patient-details__name">
        ${e.name}
      </div>
      <div class="dss-header-menu-patient-details__info">
        ${e.cip ? i`
            <span class="dss-header-menu-patient-details__info-label dss-header-menu-patient-details__info-label--cip">
              ${e.cip}
            </span>
            <span class="divider-v divider-v--cip"></span>
          ` : null}
        ${e.age ? i`
            <span class="dss-header-menu-patient-details__info-label">
              ${e.age}
              ${e.ageLabel ? i`${e.ageLabel.trim().charAt(0)}.` : s}
            </span>
            <span class="divider-v"></span>
          ` : null}
        ${e.gender ? i`
            <span class="dss-header-menu-patient-details__info-label">
              ${e.gender}
            </span>
          ` : null}
      </div>
    </div>
    <${a}
      class="dss-header-menu-patient__toggle-action"
      icon="${e._toggleIcon}"
      label="${e._toggleLabel}"
      variant="primary"
      @onClick="${e._toggleDropdown}"
      ?disabled=${e.disabled}
      ariaLabel="${e._toggleLabel} menú pacient"
      ariaExpanded="${e._showDropdown ? "true" : "false"}"
      hideTooltip
    ></${a}>
    ${e._showDropdown ? i`
          <div
            id="menu-patient"
            class=${h({
  "dss-header-menu-patient-dropdown": !0,
  "dss-header-menu-patient-dropdown--expanded": !!e._showDropdown
})}
          >
            <div class="dss-header-menu-patient-dropdown__info">
              <div class="dss-header-menu-patient-dropdown__title">
                ${e.infoLabel}
              </div>

              <div class="dss-header-menu-patient-dropdown__content">
                <div class="dss-header-menu-patient-dropdown__subtitle">
                  ${e.name}
                </div>

                ${e.cip ? i`
                  <div class="dss-header-menu-patient-dropdown__group dss-header-menu-patient-dropdown__group--cip">
                    <span class="dss-header-menu-patient-dropdown__description__cip">
                      ${e.cip}
                    </span>
                    ${e.hideCopyCip ? s : i`
                        <${a}
                          icon="content_copy"
                          size="sm"
                          label="Copiar CIP"
                          variant="primary"
                          @onClick="${e._handleCIPClick}"
                          ?disabled=${e.disabled}
                          ?tooltipFixed=${e.tooltipFixed}
                        ></${a}>
                      `}
                   
                  </div>
                  ` : s}

                ${e.age ? i`
                    <div class="dss-header-menu-patient-dropdown__group">
                      <${t} icon="person" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description">
                        ${e.age}
                        ${e.ageLabel ? i`${e.ageLabel}` : s}
                      </div>
                    </div>
                  ` : s}

                ${e.gender ? i`
                    <div class="dss-header-menu-patient-dropdown__group">
                      <${t} icon="${e._getGenderIcon()}" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description">
                        ${e.gender}
                      </div>
                    </div>
                  ` : s}

                ${e.phoneMain ? i`
                    <div class="dss-header-menu-patient-dropdown__group">
                      <${t} icon="phone" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description">
                        ${e.phoneMain}
                      </div>
                      ${e.hasPhoneMainCall ? i`
                        <${a}
                          size='sm'
                          icon='phone_forwarded'
                          label="Trucar al telèfon principal"
                          hideTooltip
                          @click=${() => e._handlePhoneCall(e.phoneMain)}
                        ></${a}>
                        ` : s}
                      ${e.hasPhoneMainChat ? i`
                        <${a}
                          size='sm'
                          icon='sms'
                          label="Enviar missatge al telèfon principal"
                          hideTooltip
                          @click=${() => e._handlePhoneChat(e.phoneMain)}
                        ></${a}>
                        ` : s}
                    </div>
                  ` : s}

                ${e.phoneAlt ? i`
                    <div class="dss-header-menu-patient-dropdown__group">
                      <${t} icon="phone" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description">
                        ${e.phoneAlt}
                      </div>
                       ${e.hasPhoneAltCall ? i`
                        <${a}
                          size='sm'
                          icon='phone_forwarded'
                          label="Trucar al telèfon alternatiu"
                          hideTooltip
                          @click=${() => e._handlePhoneCall(e.phoneAlt)}
                        ></${a}>
                        ` : s}
                      ${e.hasPhoneAltChat ? i`
                        <${a}
                          size='sm'
                          icon='sms'
                          label="Enviar missatge al telèfon alternatiu"
                          hideTooltip
                          @click=${() => e._handlePhoneChat(e.phoneAlt)}
                        ></${a}>
                        ` : s}
                    </div>
                  ` : s}

                ${e.mail ? i`
                    <div class="dss-header-menu-patient-dropdown__group">
                      <${t} icon="mail" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description" @mouseenter=${r}>
                        ${e.mailHref ? i`
                          <a class="dss-header-menu-patient-dropdown__link" href="${e.mailHref}" target="_blank" rel="noopener">
                            ${e.mail}
                          </a>
                          ` : i`
                            ${e.mail}
                          `}
                        <${d} 
                          class="description-tooltip" 
                          aria-hidden="true" 
                          interactive
                          ?tooltipFixed=${e.tooltipFixed}      
                        >
                          ${e.mail}
                        </${d}>
                      </div>
                    </div>
                  ` : s}

                ${e.address ? i`
                    <div class="dss-header-menu-patient-dropdown__group dss-header-menu-patient-dropdown__group--address">
                      <${t} class="address-icon" icon="home_work" size="sm"></${t}>
                      <div class="dss-header-menu-patient-dropdown__description dss-header-menu-patient-dropdown__description--address" @mouseenter=${_}>
                        <a class="dss-header-menu-patient-dropdown__link" href="${e.addressURL}" target="_blank" rel="noopener">
                          ${e.address}
                        </a>
                        <${d} 
                          class="description-tooltip" 
                          aria-hidden="true" 
                          interactive
                          ?tooltipFixed=${e.tooltipFixed}
                        >
                          ${e.address}
                        </${d}>
                      </div>
                    </div>
                  ` : s}

                ${e.assignments ? i`
                  <div class="dss-header-menu-patient-dropdown__assignments">
                    <div class="dss-header-menu-patient-dropdown__title dss-header-menu-patient-dropdown__title--assigned">
                      ${e.assignedLabel}
                    </div>

                    ${e.assignments.uab ? i`
                      <div class="dss-header-menu-patient-dropdown__group">
                        <div class="dss-header-menu-patient-dropdown__area">UAB</div>
                        <div class="dss-header-menu-patient-dropdown__description" @mouseenter=${r}>
                          ${e.assignments.uab}
                          <${d} 
                            class="description-tooltip" 
                            aria-hidden="true" 
                            interactive
                            ?tooltipFixed=${e.tooltipFixed}
                          >
                            ${e.assignments.uab}
                          </${d}>
                        </div>
                      </div>
                      ` : s} 

                    ${e.assignments.ui ? i`
                      <div class="dss-header-menu-patient-dropdown__group">
                        <div class="dss-header-menu-patient-dropdown__area">UI</div>
                        <div class="dss-header-menu-patient-dropdown__description" @mouseenter=${r}>
                          ${e.assignments.ui}
                          <${d} 
                            class="description-tooltip" 
                            aria-hidden="true" 
                            interactive
                            ?tooltipFixed=${e.tooltipFixed}
                          >
                            ${e.assignments.ui}
                          </${d}>
                        </div>
                      </div>
                      ` : s} 

                    ${e.assignments.uas ? i`
                      <div class="dss-header-menu-patient-dropdown__group">
                        <div class="dss-header-menu-patient-dropdown__area">UAS</div>
                        <div class="dss-header-menu-patient-dropdown__description" @mouseenter=${r}>
                          ${e.assignments.uas}
                          <${d} 
                            class="description-tooltip" 
                            aria-hidden="true" 
                            interactive
                            ?tooltipFixed=${e.tooltipFixed}
                          >
                            ${e.assignments.uas}
                          </${d}>
                        </div>
                      </div>
                      ` : s} 

                    ${e.assignments.center ? i`
                      <div class="dss-header-menu-patient-dropdown__group">
                        <div class="dss-header-menu-patient-dropdown__description" @mouseenter=${r}>
                          ${e.assignments.center}
                          <${d} 
                            class="description-tooltip" 
                            aria-hidden="true" 
                            interactive
                            ?tooltipFixed=${e.tooltipFixed}
                          >
                            ${e.assignments.center}
                          </${d}>
                        </div>
                        ${e.assignments.up ? i`
                          <${u} size="sm" state="info" outlined text="${e.upLabel}">
                            <${d}
                              ?tooltipFixed=${e.tooltipFixed}
                              slot="tooltip"
                             > 
                              ${e.upMessage} 
                            </${d}>
                          </${u}>
                        ` : s}
                      </div>
                      ` : s} 
                  </div>
                ` : s}
              </div>
            </div>

            ${!e.hideViewDetails || e.edit ? i`
                <div class="dss-header-menu-patient-dropdown__actions">
                  ${e.hideViewDetails ? s : i`
                      <${p}
                        variant="link"
                        size="md"
                        label="${e.detailsLabel}"
                        fullWidth
                        @click="${e._handleViewDetails}"
                      </${p}>
                    `}
                  ${e.edit ? i`
                      <${p}
                        variant="link"
                        size="md"
                        label="${e.editLabel}"
                        icon="open_in_new" 
                        iconPosition="right"
                        fullWidth
                        @click="${e._handleEdit}"
                      </${p}>
                    ` : s}
                </div>` : s}

          </div>
        ` : null}
  </div>
`;
export {
  b as headerMenuPatientTemplate
};
//# sourceMappingURL=header-menu-patient.template.js.map
